export const addZeroPrefix = (value) => {
    if(!value) return "";
    return String(value).padStart(2, "0");
}

export const generateTimeArray = () => {
    const times = [];
    // Loop through hours and minutes
    for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute++) {
            // Construct time string with leading zeros and AM/PM designation
            let hour12 = hour % 12 || 12; // Convert 24-hour format to 12-hour format
            const meridiem = hour < 12 ? 'AM' : 'PM';
            const timeString = `${String(hour12).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${meridiem}`;

            // Push object to array
            times.push({ id: timeString, display: timeString });
        }
    }

    return times;
}

//Calculate time difference from given time to now in the format of dd:hh:mm
export const calculateTime = (givenDate) => {
    const currentDate = new Date(new Date().toISOString());
    const givenDateTime = new Date(givenDate);

    // Calculate the difference in milliseconds
    const timeDifference = currentDate - givenDateTime;

    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const msToMinutes = (ms) => {
    return ms / (1000 * 60); // 1 minute = 1000 milliseconds * 60 seconds
}

export const calculateHoursBetweenDates = ({startDate, endDate, withSeconds = false }) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Calculate the difference in milliseconds
    const timeDifference = end - start;
    const timeDifferenceInMinutes = msToMinutes(timeDifference)
    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const remainingTime = timeDifference % (1000 * 60 * 60);
    
    const minutes = Math.floor(remainingTime / (1000 * 60));
    const seconds = Math.floor(remainingTime % (1000 * 60)) / 1000;

    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");


    if (withSeconds) {
        return {timeDifferenceInMinutes, total: `${formattedHours}:${formattedMinutes}:${formattedSeconds}`};
    } else {
        return {timeDifferenceInMinutes, total: `${formattedHours}:${formattedMinutes}`};
    }
};

export const convertSecondsToTime = (seconds) => {
    if (!seconds) return '00:00:00';    
    const hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;
    const minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;

    // Format the result
    const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    return formattedTime;
}

export const getAssociatedStopEvent = ({ index, events }) => {
    for (let idx = index; idx < events.length; idx++) {
        const event = events[idx];
        if (event.event_name === 'stop_timer') {
            return event;
        }
    }
    return null;
};

export const createPayLoadDateTime = ({ time, date }) => {
    const [timePart, meridiem] = time.split(' ');
    const [hours, minutes] = timePart.split(':').map((part) => parseInt(part, 10));
  
    // Adjust hours for PM and AM
    let adjustedHours = hours;
    if (meridiem === 'PM' && hours !== 12) {
      adjustedHours += 12;
    } else if (meridiem === 'AM' && hours === 12) {
      adjustedHours = 0;
    }
  
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), adjustedHours, minutes);
  };